module.exports = __webpack_public_path__ + "assets/addonevgo.4813d0b3.svg";